import {Step} from 'react-joyride';
import {tourText} from '../../texts/microlessonsText';
import {stepConfig} from './microlessonsStepConfig';
import {buildSteps} from '../../utils/buildSteps';

export const getMicrolessonsSteps = (): Step[] =>
  buildSteps(stepConfig, tourText, 'Microlessons');
